import { CanceledError } from 'axios'

export class DomainApiError extends Error {
  resultCode?: number | string
  httpStatus?: number
  retryable?: boolean

  constructor(params: {
    message: string
    resultCode?: number | string
    httpStatus?: number
    retryable?: boolean
  }) {
    super(params.message)
    this.name = 'DomainApiError'
    this.resultCode = params.resultCode
    this.httpStatus = params.httpStatus
    this.retryable = params.retryable ?? false
  }
}

export const isDomainApiError = (error: unknown): error is DomainApiError => {
  return error instanceof DomainApiError
}

export const isSkippableQueryError = (error: unknown): boolean => {
  if (error instanceof CanceledError) return true
  if (isDomainApiError(error) && error.message === 'canceled') return true
  return false
}

export const getDomainApiErrorI18nKey = (error: DomainApiError): string | null => {
  if (error.resultCode === undefined || error.resultCode === null || error.resultCode === '') {
    return null
  }

  return `ServerResponse.ResultCode.${error.resultCode}`
}
